<template>
    <div ref="container" class="navbar-home-sport-search">
        <div class="navbar-dropdown-sport-search">
            <div class="d-flex input-group">
                <div class="dropdown">
                    <button type="button" @click="onClickDropdown"
                            class="btn p-0 btn-outline-secondary search-world-navbar-button"
                            :class="{'border-none': dropdownOpen}" id="showCloseSearchbarHeader">
                        <i class="fa fa-search"></i>
                        <span class="d-none d-md-inline">Cerca</span>
                    </button>
                    <div class="dropdown-search-menu shadow" v-show="dropdownOpen">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="line-height-28 font-weight-bold">Cerca su Orangogo</h3>

                                    <div class="d-flex align-items-center">
                                        <div class="form-group flex-fill">
                                            <div class="d-flex input-group">
                                                <div class="form-control pl-2 gen-search">
                                                    <input type="text" v-model="search_string" placeholder="Tutti gli sport"
                                                        class="inner-form">
                                                </div>

                                                <div class="form-control input-pos-container">
                                                    <gmap-autocomplete
                                                        placeholder="Ovunque"
                                                        @place_changed="setPlace"
                                                        @focus.native="onFocus(false)"
                                                        @input.native="changeAddress"
                                                        @blur.native="onBlur"
                                                        ref="mypos"
                                                        class="inner-form"
                                                        v-model="municipality.name"
                                                    >
                                                    </gmap-autocomplete>
                                                    <div class="mypos-container mypos-logo" v-if="inputType === false">
                                                        <div class="mypos-item" @click="setMyPosition">
                                                            <span class="mypos-icon mypos-icon-marker"></span>
                                                            <span class="mypos-item-query">La mia posizione</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="input-group-append">
                                                    <button type="button"
                                                        @click="sendGA"
                                                        class="btn btn-primary-gradient text-white text-uppercase navbar-search-button fw-500">
                                                        Cerca <img src="/images/icons/complete-arrow-right-icon.svg">
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="d-flex align-items-center justify-content-center d-md-none">
                                        <button type="button" data-toggle="modal" data-target="#searchCompanyFormModal" class="mt-3 font-14 fw-500 line-height-18 btn btn-outline-search">
                                          Cerchi una struttura sportiva?
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="d-none d-md-block search-companies__container">
                                <div class="row">
                                    <div class="col-12">
                                        <h1 class="font-24 line-height-28 font-weight-bold">Cerchi una struttura sportiva?</h1>

                                        <div class="d-inline-flex w-auto input-group mb-3">
                                            <div class="input-group-prepend">
                                                <i class="fa fa-search"></i>
                                            </div>
                                            <input type="text" class="pl-2 form-control" @focus="onSearchCompanies" @input="onSearchCompanies" placeholder="Inserisci nome">
                                        </div>
                                    </div>
                                </div>

                                <div class="list-group" v-if="companies.length > 0">
                                    <div v-for="company in companies" class="list-group-item">
                                        <div @click="onShowCompanyPage(company)" class="clickable list-group-item__icon-company">
                                            <p class="font-14 fw-500 line-height-18 mb-0">{{company.public_name}}</p>
                                            <span class="d-block text-uppercase font-12 line-height-16">
                                                {{company.address}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.mypos-container {
    background-color: #fff;
    position: absolute!important;
    top: 35px !important;
    left: 1px;
    z-index: 1000;
    width: 100% ;
    border-radius: 2px;
    border-top: 1px solid #d9d9d9;
    font-family: Arial,sans-serif;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}

.mypos-container.mypos-logo {
    z-index: 99999999;
}

.mypos-item {
    cursor: default;
    padding: 0 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 30px;
    text-align: left;
    border-top: 1px solid #e6e6e6;
    font-size: 11px;
    color: #999;
}

.mypos-icon-marker {
    background-position: -1px -161px;
}

.mypos-icon {
    width: 15px;
    height: 20px;
    margin-right: 7px;
    margin-top: 6px;
    display: inline-block;
    vertical-align: top;
    background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);
    background-size: 34px;
}

.mypos-item-query {
    font-size: 13px;
    padding-right: 3px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.3px;
    color: rgba(74, 74, 74, 0.9);
}
</style>
<script>
    export default {
        props: {
            url: String
        },
        data() {
            return {
                companies: [],
                search_string_label: '',
                search_string: null,
                municipality: {
                    name: null
                },
                coords: [],
                municipalities: [],
                isFocused: false,
                navbarStyle: {},
                diffWidth: 0,
                navbarContainer: 0,
                canActivate: !$('.navbar-collapse').is(':visible'),
                totalCount: 0,
                dropdownOpen: false,
                inputType: true,
                requiredWhere: false
            }
        },
        computed: {
            dropdownWidth() {
                let dropDownwidth = document.getElementsByClassName('navbar-default-orangogo')[0].clientWidth
                return dropDownwidth
            }
        },
        mounted() {
            let self = this;
            this.navbarContainer = document.getElementsByClassName('navbar--container')[0].clientWidth
            this.init();

            this.search_string = this.getParameterByName('search_string');

            this.getLocation();

            $(".navbar-home-sport-search").keyup((event) => {
                event.preventDefault();
                if (event.keyCode == 13) {
                    this.sendGA()
                }
            });

            $("#searchCompanyFormModal").on('shown.bs.modal', () => {
                this.dropdownOpen = false
            })

            let initialData = []
            let municipality = this.getParameterByName('municipality')
            if (municipality && municipality.length) {
                this.municipality = {name: municipality}
                initialData.push({id: municipality, text: municipality})
            }

            $(document).mouseup(function(e)
            {
                var container = $(".navbar-default-orangogo");
                // if the target of the click isn't the container nor a descendant of the container
                if ($(e.target).parents('.page-content').length > 0)
                {
                    if($('.dropdown-search-menu').is(':visible')){
                        $('#showCloseSearchbarHeader').click()
                    }
                }
            });

            $('.search--select2').select2({
                allowClear: true,
                data: initialData,
                placeholder: 'Dove?',
                ajax: {
                    url: `${axios.defaults.baseURL}paginate/municipalities`,
                    data: (params) => {
                        let query = {
                            term: params.term,
                            page: params.page || 1
                        }
                        return query
                    },
                    processResults: (response, params) => {
                        let results = []
                        if (response.municipalities.hasOwnProperty('data')) {
                            response.municipalities.data.forEach(m => {
                                results.push({
                                    id: m.name,
                                    text: m.name
                                })
                            })
                            params.page = response.municipalities.current_page

                            return {
                                results: results,
                                pagination: {
                                    more: (params.page * 10) < response.municipalities.total
                                }
                            }
                        }

                        return {
                            results: results,
                            pagination: {
                                more: false
                            }
                        }
                    }
                }
            })
            $('.search--select2').on('select2:select', (e) => {
                this.municipality = {
                    name: e.params.data.id
                }
            })
            if (initialData.length > 0) {
                $('.search--select2').val(municipality).trigger('change')
            }
            $('.search--select2').on('select2:unselect', (e) => {
                this.municipality = {name: ''}
            })

            let vm = this
            $('.navbar-toggler').on('click', function () {
                vm.dropdownOpen = false
            })
            this.$bus.$on('update-count', (data) => {
                this.totalCount = data.count
            })

            $(window).on('resize', function (e) {
                vm.navbarContainer = document.getElementsByClassName('navbar--container')[0].clientWidth
                vm.$set(vm, 'navbarContainer', document.getElementsByClassName('navbar--container')[0].clientWidth)
                vm.$set(vm, 'canActivate', !$('.navbar-collapse').is(':visible'))
                vm.init()
            });
        },
        watch: {
            isFocused(val) {
                if (val) {
                    this.navbarStyle = {
                        width: `${this.navbarContainer}px`
                    }
                } else {
                    this.navbarStyle = {
                        width: `${this.navbarContainer - this.diffWidth}px`
                    }
                }
            }
        },
        methods: {
            onShowCompanyPage(company) {
                location.href = route('company.show', company.slug)
            },
            onSearchCompanies(e) {
                this.searchCompanies(this, e.target.value)
            },
            searchCompanies: _.debounce((vm, term) => {
                let url = route('companies.search')

                axios
                    .get(`${url}?term=${window.encodeURIComponent(term)}`)
                    .then(response => {
                        vm.$set(vm, 'companies', response.data.companies)
                    })
            }, 500),
            onClickDropdown() {
                this.dropdownOpen = !this.dropdownOpen
            },
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');

                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);

                if (!results) return '';
                if (!results[2]) return '';

                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition, this.errorPosition);
                }
            },
            getSearchUrl() {
                let municipality = this.municipality ? this.municipality.name : ''
                if (this.coords.length != 0) {
                    return this.url +
                        '?search_string=' +
                        this.search_string +
                        '&municipality=' +
                        municipality +
                        '&latitude=' +
                        this.coords[0] +
                        '&longitude=' +
                        this.coords[1]
                } else {
                    return this.url +
                        '?search_string=' +
                        this.search_string +
                        '&municipality=' +
                        municipality +
                        '&latitude=' +
                        null +
                        '&longitude=' +
                        null
                }
            },
            returnPosition(position) {
                this.coords.push(position.coords.latitude);
                this.coords.push(position.coords.longitude);

                this.$bus.$emit('geolocalizated', {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            },
            errorPosition(error) {
                this.requiredWhere = true;
            },
            sendGA() {
                // ga('send', 'event', 'Ricerca', 'RicercaCorso', 'Header');
                window.location = this.getSearchUrl();
            },
            init() {
                if (!this.canActivate) {
                    this.navbarStyle = {
                        width: 'auto'
                    }
                } else {
                    this.diffWidth = this.navbarContainer - $(this.$refs.container).parent().innerWidth()
                    this.navbarStyle = {
                        width: `${$(this.$refs.container).parent().innerWidth()}px`
                    }
                }
            },
            toggleFocus() {
                this.isFocused = !this.isFocused
            },
            getSearchStringLabel() {
                if (_.isObject(this.municipality)) {
                    this.search_string_label = `${this.search_string} ${this.municipality.name}`
                } else {
                    this.search_string_label = this.search_string
                }
            },
            setPlace(place) {
                if (place) {
                    this.coords = [];
                    this.coords.push(place.geometry.location.lat());
                    this.coords.push(place.geometry.location.lng());
                    // this.$bus.$emit('geolocalizated', {
                    //     latitude: place.geometry.location.lat(),
                    //     longitude: place.geometry.location.lng(),
                    // });
                    this.municipality = { name: place.formatted_address };
                }
            },
            onFocus(action) {
                if(this.requiredWhere == false)
                this.inputType = false
            },
            onBlur() {
                setTimeout(() => this.inputType = true, 200);
            },
            changeAddress() {
                if(this.$refs.mypos.$refs.input.value !== '')
                    this.inputType = true
                else if(this.requiredWhere == false) {
                    this.inputType = false
                    this.coords = []
                    this.getLocation()
                } else
                    this.coords = []
            },
            setMyPosition() {
                this.coords = []
                this.getLocation()
                this.$refs.mypos.$refs.input.value = 'La mia posizione'
                this.municipality.name = 'La mia posizione'
                this.inputType = true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/SearchNavbar.vue